"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsbyLink = _interopRequireDefault(require("gatsby-link"));

var _helpers = require("@tryghost/helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Tags = function Tags(props) {
  var opts = {
    limit: props.limit,
    from: props.from,
    to: props.to,
    fallback: props.fallback,
    visibility: props.visibility
  };
  var keyIndex = 0;

  var generateKey = function generateKey(pre) {
    keyIndex = keyIndex + 1;
    return "".concat(pre, "_").concat(keyIndex);
  };

  Object.defineProperty(opts, 'separator', {
    get: function get() {
      if (props.separator === '') {
        return null;
      } else if (_react["default"].isValidElement(props.separator)) {
        return _react["default"].createElement(_react["default"].Fragment, {
          key: generateKey('separator')
        }, props.separator);
      }

      return _react["default"].createElement("span", {
        className: props.separatorClasses,
        key: generateKey('separator')
      }, props.separator);
    }
  });

  if (props.prefix) {
    opts.prefix = _react["default"].isValidElement(props.prefix) ? props.prefix : _react["default"].createElement("span", {
      className: props.prefixClasses,
      key: "prefix"
    }, props.prefix);
  }

  if (props.suffix) {
    opts.suffix = _react["default"].isValidElement(props.suffix) ? props.suffix : _react["default"].createElement("span", {
      className: props.suffixClasses,
      key: "suffix"
    }, props.suffix);
  }

  opts.fn = function process(tag) {
    var tagLink = props.permalink;
    tagLink = tagLink.replace(/:slug/, tag.slug) || "/".concat(tag.slug, "/");
    return props.autolink ? _react["default"].createElement("span", {
      className: props.classes,
      key: tag.slug
    }, _react["default"].createElement(_gatsbyLink["default"], {
      to: tagLink,
      className: props.linkClasses
    }, tag.name)) : _react["default"].createElement("span", {
      className: props.classes,
      key: tag.slug
    }, tag.name);
  };

  return (0, _helpers.tags)(props.post, opts);
};

Tags.defaultProps = {
  separator: ", ",
  from: 1,
  classes: "",
  separatorClasses: "",
  prefixClasses: "",
  suffixClasses: "",
  linkClasses: "",
  permalink: "/:slug/",
  autolink: true
};
Tags.propTypes = {
  post: _propTypes["default"].shape({
    tags: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      name: _propTypes["default"].string,
      slug: _propTypes["default"].string
    })).isRequired
  }).isRequired,
  limit: _propTypes["default"].number,
  from: _propTypes["default"].number,
  to: _propTypes["default"].number,
  fallback: _propTypes["default"].object,
  visibility: _propTypes["default"].oneOf(["public", "all", "internal"]),
  permalink: _propTypes["default"].string,
  autolink: _propTypes["default"].bool,
  classes: _propTypes["default"].string,
  separatorClasses: _propTypes["default"].string,
  prefixClasses: _propTypes["default"].string,
  suffixClasses: _propTypes["default"].string,
  linkClasses: _propTypes["default"].string
};
var _default = Tags;
exports["default"] = _default;